module.exports = __webpack_public_path__ + "img/portrait-026.de67a8bb.jpg";